export const PLAN_COMPARISON_DRAWER = 'plan-comparison-drawer'
